import { Enums } from '@bode-canada/core';

// eslint-disable-next-line import/prefer-default-export
export class FiltersCreateHelper {
  static getFilterValues(allowedProperties, filter) {
    if (filter === Enums.BuildingClassEnum.VACANT_LAND) {
      return [Enums.BuildingClassEnum.VACANT_LAND];
    }

    return allowedProperties.includes(filter)
      ? this.#getFiltersWithFirstSearchCriteria(filter, allowedProperties)
      : null;
  }

  static #getFiltersWithFirstSearchCriteria(filter, allowedProperties) {
    return [
      filter,
      ...allowedProperties.filter((value) => value !== filter),
    ];
  }
}
